<template>
    <v-navigation-drawer
      app
      clipped=""
      style="position:fixed;"
      right
      v-if="inventoryActive"
      class="elevation-3"
      :value="inventoryActive"
      >
        <v-layout fill-height="" column="">
          <v-flex shrink>
            <v-col class="pb-0 pt-0">
              <v-row style="background-color:#3d3d3d; color:white;">
                <v-col class="pb-0 pt-0">
                  <v-subheader style="color:white">
                    {{(inventoryAssetList.id == null) ? 'Creating new asset list' : 'Editing asset list'}}
                    </v-subheader>
                </v-col>
                <v-col cols="auto" >
                  <v-btn icon="" small dark class="ma-0" v-on:click="SetInventoryActiveState(false)">
                    <v-icon>
                      mdi-close
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-divider/>
              </v-row>
              <v-row>
                <v-col class="pb-1 pt-1">
                  <v-text-field v-model="assetListName" filled dense="" hide-details="" label="Asset List Name" v-on:change="OnChangeName()"/>
                </v-col>
              </v-row>
            </v-col>
          </v-flex>

          <v-flex style="overflow-y: scroll;background-color:#e4e4e4" class="pa-1 pl-3 pr-3">
            <asset-card v-for="(asset,i) in inventorySearchResults.results" 
            :showDelete="userCanEdit" 
            :key="asset.id" 
            :asset="asset" 
            :imageHeight="100" 
            class="ma-1" 
            v-on:onDelete="OnRemoveAsset"
            >
            </asset-card>
            <v-card height="40px" width="100px" color="transparent" flat>
              <infinite-loading :identifier="infiniteIncrementor" @infinite="infiniteHandler">
                  <div slot="spinner">Loading...</div>
                  <div slot="no-more"></div>
                  <div slot="no-results"></div>
              </infinite-loading>
            </v-card>
            <v-card height="86px" flat color="transparent">

            </v-card>
          </v-flex>

          <v-card style="position:absolute; bottom:0px;" width="100%" height="46px" color="#3d3d3d" class="pa-0 elevation-12">
            <v-layout fill-height="" column="">
              <!--
              <v-flex class="pa-0 pb-0">
                <v-card class="text-md-center" hover="" height="100%" width="100%" color="grey" >
                  <v-layout fill-height="">
                    <v-spacer>
                    </v-spacer>
                    <v-flex shrink align-self-center="" class="mr-2">
                      <v-icon color="white">
                        mdi-file-pdf
                      </v-icon>
                    </v-flex>
                    <v-flex shrink align-self-center="" style="color:white" class="font-weight-bold">
                      EXPORT AS PDF
                    </v-flex>
                    <v-spacer/>
                  </v-layout>
                </v-card>
              </v-flex>-->
              <v-flex class="pa-0 pt-0" >
                <v-card class="text-md-center" hover="" height="100%" width="100%" color="red" @click="OnUpsertAssetList()">
                  <v-layout fill-height="">
                    <v-spacer>
                    </v-spacer>
                    <v-flex shrink align-self-center="" class="mr-2">
                      <v-icon color="white">
                        mdi-upload
                      </v-icon>
                    </v-flex>
                    <v-flex shrink align-self-center="" style="color:white" class="font-weight-bold" >
                      {{(inventoryAssetList.id == null) ? 'Create' : 'Update'}}
                    </v-flex>
                    <v-spacer/>
                  </v-layout> 
                </v-card>
              </v-flex>
            </v-layout>
            
        
          </v-card>
        </v-layout>
      
      </v-navigation-drawer>
</template>

<script>

  import AssetCard from './cards/AssetCard'
  import InfiniteLoading from 'vue-infinite-loading';

  import { mapState } from 'vuex'
  import { mapMutations} from 'vuex'
  import { mapActions } from 'vuex'
  import { mapGetters } from 'vuex'

  export default {
    components: {AssetCard,InfiniteLoading},
    computed : {

      ...mapState("assetxpstate", [
        "inventoryActive",
        "inventoryAssetList",
        "inventorySearchResults",
        "section"
      ]),
      userCanEdit() {
        return this.CanUserEditAssets();
      },

    },
    data: () => ({
      infiniteIncrementor : 0,
      performingSearch : false,
      assetListName : "",
      itemRemoved : false,
    }),
    props: {
      source: {
        default : "",
        type : String
      },
    },
    mounted :  function () {},
    methods: {
      ...mapGetters("authentication", [
        "CanUserEditAssets"
    ]),
      ...mapActions("assetxpstate", [
        "SearchWithAssetList",
        "UpsertAssetList"
      ]),
      ...mapMutations("assetxpstate", [
        "ClearInventorySearch",
        "RemoveAssetFromInventoryAssetList",
        "SetInventoryActiveState",
        "ChangeCurrentInventoryListName"
      ]),
      OnChangeName()
      {
        this.ChangeCurrentInventoryListName(this.assetListName);
      },
      OnUpsertAssetList(list)
      {
        this.OnChangeName();
        this.UpsertAssetList(this.inventoryAssetList).then( (assetList) =>{

          this.SetInventoryActiveState(false);

          if(this.$route.name == "Section Asset Lists")
          {
            this.$router.go();
          }
        });
      },
      OnAssetSelected(eventObj) {
      var listingid = eventObj.id;
      var value = eventObj.value;
      var index = this.selectedAssets.indexOf(listingid);

      //if asset is not selected but was previously in the selected list
      if(value === false && index >= 0) {
        this.selectedAssets.splice(index, 1);
      }

      //if asset is selected and is not already in the selected list
      if(value === true && index < 0) {
        this.selectedAssets.push(listingid);
      }
    },
      OnRemoveAsset(asset)
      {
        this.itemRemoved = true;
        this.RemoveAssetFromInventoryAssetList(asset.id);
      },
      infiniteHandler($state) {

        var searchParams = {
          token : this.inventorySearchResults.token,
          list : this.inventoryAssetList,
          commit : true
        };

        this.performingSearch = true;
        this.SearchWithAssetList(searchParams).then( () => {

          this.performingSearch = false;
          if (this.inventorySearchResults.hasNextPage) 
          {
            $state.loaded();
          }
          else
          {
            $state.complete();
          }
        });
      }

    },
    watch : {

      inventoryAssetList : {

        immediate : true,
        deep: true,
        handler(newVal){

          if(!this.itemRemoved)
          {
            this.ClearInventorySearch();
            this.assetListName = newVal.name;
            this.infiniteIncrementor += 1;
          }
          else
          {
            this.itemRemoved = false;
          }
        }
      },

    }
  }
</script>

<style>

</style>